module.exports = __webpack_public_path__ + "img/authentic-writing.86aa8c1b.png";